<template>
  <div
    v-if="!isMobile"
    class="account-settings-menu"
    align="center"
  >
    <el-button-group class="menu">
      <router-link
        :to="{ name: 'MyAds' }"
        tag="button"
      >
        {{ $t('account-settings.menu.my-ads') }}
      </router-link>
      <router-link
        :to="{ name: 'Messages' }"
        tag="button"
      >
        {{ $t('account-settings.menu.messages') }}
      </router-link>
      <router-link
        :to="{ name: 'MyProfile' }"
        tag="button"
      >
        {{ $t('account-settings.menu.my-profile') }}
      </router-link>
      <router-link
        :to="{ name: 'Favorites' }"
        tag="button"
      >
        {{ $t('account-settings.menu.favorites') }}
      </router-link>
      <router-link
        :to="{ name: 'About' }"
        tag="button"
      >
        {{ $t('account-settings.menu.help') }}
      </router-link>
    </el-button-group>
  </div>
</template>
<script>
  import { mapState } from 'vuex';

  export default {
    name: 'AccountSettingsMenu',
    computed: {
      ...mapState({
        isMobile: state => state.isMobile,
      }),
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/AccountSettings/AccountSettingsMenu.vue